export default __webpack_public_path__ + "static/media/pause-black.550866af.svg";